/**
 * Casamento entre os nomes de cidade dos dados e os municípios do mapa (IBGE).
 *
 * Os dados trazem só o nome da cidade, escrito de várias formas ("São Paulo",
 * "saopaulo", "Assis, SP"). Tudo é comparado por uma chave normalizada (sem
 * acento, minúscula, só letras e números), dentro do estado.
 */

export const NO_CITY = new Set(['', 'desconhecido', 'null', 'undefined'])

// Nomes usados nos dados que diferem do nome oficial do IBGE (chave = nome
// normalizado em cityKey, valor = nome oficial normalizado).
export const CITY_ALIASES = {
  SP: { riopreto: 'saojosedoriopreto', embu: 'embudasartes', mojimirim: 'mogimirim' },
  SC: { picarras: 'balneariopicarras' },
  RN: { acu: 'assu' },
  PE: { itamaraca: 'ilhadeitamaraca' },
}

// "São Paulo", "saopaulo" e "Assis, SP" → chave só com letras/números, sem acento.
export function cityKey(name) {
  const base = String(name ?? '').split(',')[0]
  return base.normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '')
}

// Índice chave → valor das cidades de um estado (soma nomes que colidem).
export function buildCityIndex(uf, stateData) {
  const index = new Map()
  const aliases = CITY_ALIASES[uf] || {}
  for (const c of stateData?.cities || stateData?.topCities || []) {
    let key = cityKey(c.name)
    if (NO_CITY.has(key)) continue
    key = aliases[key] || key
    index.set(key, (index.get(key) || 0) + c.leads)
  }
  return index
}

// Chaves que identificam uma cidade nos dados: a do nome oficial e as dos apelidos
// que apontam para ela (ex.: "rio preto" → São José do Rio Preto). Vai para o backend.
export function cityFilterKeys(uf, officialName) {
  const key = cityKey(officialName)
  const aliases = Object.entries(CITY_ALIASES[uf] || {})
    .filter(([, official]) => official === key)
    .map(([alias]) => alias)
  return [key, ...aliases]
}
